export default "__VITE_ASSET__2v7ArtHG__"